import request from '@/utils/request'

function unwrap(promise, fallbackMessage) {
  return promise.then(response => {
    const res = response.data
    if (res.code === 0) return res
    throw new Error(res.msg || fallbackMessage)
  })
}

export function getWechatConfig() {
  return unwrap(request({
    url: '/wechat.admin.getConfig',
    method: 'post',
    data: {}
  }), '获取微信配置失败')
}

export function saveWechatConfig(data) {
  return unwrap(request({
    url: '/wechat.admin.saveConfig',
    method: 'post',
    data
  }), '保存微信配置失败')
}

export function listWechatSchemes(params) {
  return unwrap(request({
    url: '/wechat.admin.listSchemes',
    method: 'post',
    data: params
  }), '获取 Scheme 链接失败')
}
